import { EmployeeModel } from './../../../../model/employee.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[Employee view overview] get data', props<{ search: string, page: number }>());
export const ResponseAction = createAction('[Employee view overview] set data', props<{ payload: EmployeeModel[] }>());

export const LoadMoreAction = createAction('[Employee view overview] load more');
export const ResetAction = createAction('[Employee view overview] reset data');
